






































import { Component, Vue } from 'vue-property-decorator'
import { ReferralNode } from '@/api/model/referral-node'
import { ReferralNodeAPI } from '@/api/backend-client'
import { v4 as uuid } from 'uuid'
import { ReferralNodeType } from '@/api/types'

@Component
export default class CompanySettingsSourcesCreate extends Vue {
    referralNode: ReferralNode = null
    saving: boolean = false

    async created(): Promise<void> {
        this.referralNode = ReferralNode.fromData({
            id: uuid(),
            type: ReferralNodeType.PURCHASE,
            source: this.$currentCompany,
            target: null,
            excludedReferralFields: [],
            active: false,
        })
    }

    async save(): Promise<void> {
        this.saving = true
        this.referralNode = await ReferralNodeAPI.create({
            ...this.referralNode,
            active: this.$currentCompany.id === this.referralNode.target.id,
        } as ReferralNode)
        this.saving = false
        await this.$router.push({ name: 'company_settings_sources_list' })
    }

    async cancel(): Promise<void> {
        await this.$router.push({
            name: 'company_settings_sources_list',
        })
    }
}
